import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import Button from '../components/ui/Button'

const NotFoundPage = () => {
  const { t } = useTranslation('common')

  return (
    <div className="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8" style={{ background: 'var(--color-bg)' }}>
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <ExclamationTriangleIcon className="mx-auto h-12 w-12" style={{ color: 'var(--color-text-faint)' }} />
          <h2 className="mt-6 text-3xl font-black tracking-tight" style={{ color: 'var(--color-text)' }}>
            {t('notFoundTitle', '404 - Page not found')}
          </h2>
          <p className="mt-2 text-sm font-semibold" style={{ color: 'var(--color-text-muted)' }}>
            {t('notFoundMessage', 'Sorry, we cannot find the page you are looking for.')}
          </p>
          <div className="mt-6">
            <Button
              as={Link}
              to="/"
              variant="primary"
            >
              {t('notFoundButton', 'Back to homepage')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage
